export interface ICustomerSearchResult {
  CustomerName: string;
  AccountStatus: string;
  LastSolarAdvisor: string;
  LastInstaller: string;
  Utility: string;
  LastChannel: string;
  ServiceAddressLine1: string;
  ServiceAddressCity: string;
  ServiceAddressState: string;
  ServiceAddressZip: string;
  CustomerNumber: string;
}

export class CustomerSearchResult implements ICustomerSearchResult {
  CustomerName: string;
  AccountStatus: string;
  LastSolarAdvisor: string;
  LastInstaller: string;
  Utility: string;
  LastChannel: string;
  ServiceAddressLine1: string;
  ServiceAddressCity: string;
  ServiceAddressState: string;
  ServiceAddressZip: string;
  CustomerNumber: string;
}
